'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    padding: .5em;\n    display: inline-block;\n    text-align: center;\n    border-radius: ', ';\n    width: ', ';\n    background: ', ';\n    color: ', ';\n    font-weight: 500;\n    ', ';   \n'], ['\n    padding: .5em;\n    display: inline-block;\n    text-align: center;\n    border-radius: ', ';\n    width: ', ';\n    background: ', ';\n    color: ', ';\n    font-weight: 500;\n    ', ';   \n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // export const Message = styled.p`
//     width: ${({ fullWidth }) => fullWidth ? '100%' : 'auto'};
//     border-radius: ${({ theme }) => theme.borderRadius};
//     background: ${({ type }) => theme.stateColors['error']};
// `


var Message = exports.Message = _styledComponents2.default.div(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth ? '100%' : 'auto';
}, function (_ref3) {
  var theme = _ref3.theme,
      type = _ref3.type;
  return type ? theme.stateColors[type] : theme.textColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.foreground;
}, function (_ref5) {
  var type = _ref5.type,
      theme = _ref5.theme;
  return type === 'negative' ? 'color: whitesmoke' : type === 'warning' || type === 'positive' ? 'color: #333;' : '';
}); // color: ${ ({ theme, type }) => {
//     return chroma(theme.stateColors[type]).luminance() > 0.4 ? '#333' : 'whitesmoke'
// }};
// export const SuccessMessage = styled(Message)`
//     color: green;
//     background: ${({ theme }) => theme.stateColors.success};
//     color: whitesmoke;
// `